import { render, staticRenderFns } from "./FileUploaderImage.vue?vue&type=template&id=10f114e4&scoped=true"
import script from "./FileUploaderImage.vue?vue&type=script&lang=js"
export * from "./FileUploaderImage.vue?vue&type=script&lang=js"
import style0 from "./FileUploaderImage.vue?vue&type=style&index=0&id=10f114e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f114e4",
  null
  
)

export default component.exports